import React, { useContext } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'
import { Switch } from '../../../../common/formik';

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    colors
} from '@material-ui/core';

import { 
    Select, 
    InputFiles,
    FileList,
    FieldError
} from './../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames, RequestStatus } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    warning: {
        color: colors.yellow[900]
    },
    ok: {
        color: colors.green[900]
    }
}));

export const ContractForm = (props) => {
    const classes = useStyles();

    const {        
        state
    } = useContext(CustomerRequestContext)

    const { 
        request
    } = state;

    const { 
        values,
        setFieldValue,
        isSavingRequest
    } = useContext(TabsContext);

    const fileUploadedHandler = (storedFile) => {
        // We need to set the value manually
        // otherwise setFieldValue will not work property
        values.signedContract = storedFile;
        setFieldValue("signedContract", storedFile);
    }

    const fileRemovedHandler = (storedFile) => {
        // We need to set the value manually
        // otherwise setFieldValue will not work property
        values.signedContract = null;
        setFieldValue("signedContract", null);
    }

    // Add contract when Handled In Sap flag
    //
    // This flag is based on customer request status and determines if the user can set  the contract
    // availability. This is only used when AOF opener need to add the contract while the CR is handled by SAP
    const addContractWhenHIS = request.status === RequestStatus.WaitingToBeAddedInSap
        || request.status === RequestStatus.Approved;

    return (
        <Card>
            <CardHeader title="Customer Contract"/>
            <CardContent>
                <Grid container spacing={3}>                    
                    <Grid item xl={12} md={12} xs={12}>
                        {!addContractWhenHIS ?
                            <>
                                <Field
                                    label="Is the contract between Bulgari and the Customer available?"
                                    name="isSignedContractAvailable"
                                    disabled={isSavingRequest || props.disabled}
                                    component={Switch}
                                />
                                <FieldError name="isSignedContractAvailable" errors={state.errors} />
                            </>
                            :
                            <>
                                <Typography className={!values.isSignedContractAvailable ? classes.warning : classes.ok}>
                                    {!values.isSignedContractAvailable ? 
                                        "The contract is still missing. Please submit a valid one as soon as possibile!" : "The contract is correctly uploaded."} 
                                </Typography>
                            </>
                        }
                    </Grid>  
                                        
                    {(values.isSignedContractAvailable || addContractWhenHIS) &&                 
                        <>
                            <Grid item xl={12} md={12} xs={12}>
                                <FileList 
                                    title="Current signed contract"
                                    files={values.signedContract ? [values.signedContract] : []}
                                    disabled={props.disabled}
                                    onFileRemoved={fileRemovedHandler}
                                />
                                <FieldError name="signedContract" errors={state.errors} />
                            </Grid>
                            {!props.disabled
                                && !values.signedContract &&
                                <Grid item xl={12} md={12} xs={12}>
                                    <InputFiles 
                                        title="Upload contract"
                                        limit={1}
                                        onFileUploaded={fileUploadedHandler}/>
                                </Grid>
                            }
                        </>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}